<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-ok-bold`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.1766 4.0585C12.5671 3.668 13.2001 3.66799 13.5906 4.0585C13.981 4.44905 13.9811 5.08211 13.5906 5.47257L7.12089 11.9413C6.7304 12.3315 6.09727 12.3316 5.70683 11.9413L2.40898 8.64347C2.01854 8.25303 2.01871 7.61995 2.40898 7.2294C2.79951 6.83901 3.43256 6.83892 3.82304 7.2294L6.41484 9.82022L12.1766 4.0585Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineOkBold',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
